import { render, staticRenderFns } from "./ProductDesktop.vue?vue&type=template&id=d2f48454&scoped=true&"
import script from "./ProductDesktop.vue?vue&type=script&lang=js&"
export * from "./ProductDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ProductDesktop.vue?vue&type=style&index=0&id=d2f48454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f48454",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCardActions,VCardText,VCarousel,VCarouselItem,VContainer,VDivider,VRow,VSkeletonLoader,VSpacer})
